/**
 * Removes patterns that are unsafe when custom CSS is embedded inside a
 * `<style>` tag (e.g. preview iframe) or concatenated into generated
 * stylesheets. Intentionally small: strips breakout / script markers, null
 * bytes, and `javascript:` URLs in `url()`.
 */
export function sanitizeConsentCustomCss(css: string): string {
  if (!css) return "";

  let s = css.replace(/\0/g, "");

  s = s.replace(/<\/style\b/gi, "");
  s = s.replace(/<script\b/gi, "");
  s = s.replace(/<\/script\b/gi, "");
  s = s.replace(/<!--/g, "");

  s = s.replace(/url\s*\(\s*["']?\s*javascript:/gi, 'url("blocked:');

  return s;
}
